<template>
  <generic-modal
    :title="$t('payment')"
    :buttons="buttons"
    ref="generic_modal"
    :is_wide="true"
  >
    <form>
      <div class="columns">
        <div class="column">
          <div class="title is-4">{{ $t("payment") }}</div>
          <div
            class="field"
            v-for="(payment_method, pidx) in payment_methods"
            :key="pidx"
          >
            <label class="label">{{ payment_method.name }}</label>
            <div class="control">
              <div class="field has-addons">
                <div class="control has-icons-left">
                  <input
                    class="input"
                    type="text"
                    :placeholder="pending"
                    v-model="payment_methods[pidx].amount"
                  />
                  <span class="icon is-small is-left">
                    {{ get_currency_settings().symbol }}
                  </span>
                </div>
                <div
                  class="control"
                  v-if="
                    payment_method.percentage_of_use &&
                    payment_method.percentage_of_use > 0
                  "
                >
                  <a class="button is-static">
                    {{ payment_method.percentage_of_use }}% {{ $t("charge") }}
                  </a>
                </div>
                <div
                  class="control"
                  v-if="
                    payment_method.amount &&
                    payment_method.percentage_of_use &&
                    payment_method.percentage_of_use > 0
                  "
                >
                  <a class="button is-static">
                    {{
                      format_currency(
                        Number(payment_method.amount) +
                          (Number(payment_method.amount) *
                            Number(payment_method.percentage_of_use)) /
                            100
                      )
                    }}
                    {{ $t("total") }}
                  </a>
                </div>
                <div
                  class="control"
                  v-if="
                    module_settings.integrate_visanet_payment &&
                    payment_method.link_to_visanet_payment
                  "
                >
                  <div
                    class="button"
                    @click="
                      $emit(
                        'visanet_payment',
                        Number(payment_method.amount) +
                          (Number(payment_method.amount) *
                            Number(payment_method.percentage_of_use)) /
                            100
                      )
                    "
                  >
                    {{ $t("visanet payment") }}
                  </div>
                </div>
                <div
                  class="control"
                  v-if="payment_method.ask_for_document_number"
                >
                  <input
                    class="input"
                    type="text"
                    :placeholder="$t('document number')"
                    v-model="payment_methods[pidx].document_number"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="buttons is-pulled-right mt-2">
            <a class="button is-static is-size-5 has-text-warning">
              {{ format_currency(meta.products_data?.total_amount) }} <br />
              {{ $t("total to pay") }}
            </a>
            <a class="button is-static is-size-5 has-text-success"
              >{{ format_currency(total_payment) }} <br />
              {{ $t("payment") }}
            </a>
            <a
              class="button is-static is-size-5 has-text-danger"
              v-if="pending >= 0"
            >
              {{ format_currency(pending) }} <br />
              {{ $t("pending") }}
            </a>
            <a
              class="button is-static is-size-5 has-text-info"
              v-if="pending < 0"
            >
              {{ format_currency(Math.abs(pending)) }} <br />
              {{ $t("change") }}
            </a>
          </div>
          <div class="title is-5">
            {{ $t("inventory") }}
          </div>
          <div class="field">
            <generic-dropdown
              :title="$t('warehouse')"
              :placeholder="$t('select one')"
              :is_multiple="false"
              url="/inventory/warehouse/catalog"
              name_field="name"
              value_field="warehouse_id"
              @selected="set_warehouse"
              ref="warehouse_dropdown"
            />
          </div>
        </div>
        <div class="column">
          <div class="title is-4">{{ $t("billing") }}</div>
          <div class="field">
            <input
              class="is-checkradio"
              type="checkbox"
              id="chk_emit_billing"
              v-model="meta.emit_billing"
            />
            <label for="chk_emit_billing">{{ $t("emit billing") }}</label>
          </div>
          <div v-if="meta.emit_billing">
            <div class="field">
              <label class="label">{{ $t("nit") }}</label>
              <div class="control has-icons-left">
                <input
                  class="input"
                  type="text"
                  placeholder="3952107-9"
                  v-model="meta.billing_nit"
                />
                <span class="icon is-small is-left">
                  <i class="fa fa-id-card"></i>
                </span>
              </div>
            </div>
            <div class="field">
              <label class="label">{{ $t("name") }}</label>
              <div class="control has-icons-left">
                <input
                  class="input"
                  type="text"
                  placeholder="Luis Robledo"
                  v-model="meta.billing_name"
                /><span class="icon is-small is-left">
                  <i class="fa fa-user"></i>
                </span>
              </div>
            </div>
            <div class="field">
              <label class="label">{{ $t("email") }}</label>
              <div class="control has-icons-left">
                <input
                  class="input"
                  type="text"
                  placeholder="Luis Robledo"
                  v-model="meta.billing_email"
                /><span class="icon is-small is-left">
                  <i class="fa fa-at"></i>
                </span>
              </div>
            </div>
            <div class="field">
              <label class="label">{{ $t("address") }}</label>
              <div class="control has-icons-left">
                <input
                  class="input"
                  type="text"
                  placeholder="Luis Robledo"
                  v-model="meta.billing_address"
                /><span class="icon is-small is-left">
                  <i class="fa fa-home"></i>
                </span>
              </div>
            </div>
            <div class="field">
              <label class="label">{{ $t("zip code") }}</label>
              <div class="control has-icons-left">
                <input
                  class="input"
                  type="text"
                  v-model="meta.billing_zip_code"
                />
                <span class="icon is-small is-left">
                  <i class="fa fa-map-marker"></i>
                </span>
              </div>
            </div>

            <div class="field">
              <label class="label">{{ $t("municipality") }}</label>
              <div class="control has-icons-left">
                <input
                  class="input"
                  type="text"
                  v-model="meta.billing_municipality"
                />
                <span class="icon is-small is-left">
                  <i class="fa fa-globe"></i>
                </span>
              </div>
            </div>
            <div class="field">
              <label class="label">{{ $t("department") }}</label>
              <div class="control has-icons-left">
                <input
                  class="input"
                  type="text"
                  v-model="meta.billing_department"
                />
                <span class="icon is-small is-left">
                  <i class="fa fa-globe"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>

    <!-- <pre>{{ meta }}</pre> -->
    <!-- <pre>{{ $props.module_settings }}</pre> -->
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        :class="{ 'is-loading': is_loading }"
        @click="save"
        :disabled="is_form_invalid || is_loading"
      >
        <span class="icon">
          <i class="fa fa-credit-card"></i>
        </span>
        <span>{{ $t("register payment") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  generate_error_message_text,
  get_currency_settings,
  format_currency,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";

export default {
  name: "PaymentModal",
  components: { GenericModal, GenericDropdown },
  props: {
    module_settings: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      buttons: [
        // {
        //   text: this.$t("register payment"),
        //   class: "is-primary is-rounded",
        //   icon: "fa fa-credit-card",
        //   click: this.save,
        // },
        // {
        //   text: this.$t("cancel"),
        //   class: "is-rounded",
        //   icon: "fa fa-close",
        //   click: this.close_modal,
        // },
      ],
      meta: {},
      error: "",
      payment_methods: [],
      is_loading: false,
      // uuid: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      // console.log("v.meta", v.meta);
      let billing_condition = false;
      if (v.meta.emit_billing) {
        billing_condition =
          !v.meta.billing_nit ||
          !v.meta.billing_name ||
          !v.meta.billing_email ||
          !v.meta.billing_address ||
          !v.meta.billing_zip_code ||
          !v.meta.billing_municipality ||
          !v.meta.billing_department;
      }
      // console.log("billing_condition", billing_condition);
      return v.pending > 0 || billing_condition;
    },
    total_payment() {
      let v = this;
      return v.payment_methods.reduce((acc, pm) => {
        if (pm.amount) return acc + Number(pm.amount);
        else return acc;
      }, 0);
    },
    pending() {
      let v = this;
      return v.meta.products_data?.total_amount - v.total_payment;
    },
  },
  methods: {
    get_currency_settings,
    format_currency,
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show_modal(products_data) {
      // console.log("products_data", products_data);
      let v = this;
      v.set_initial_state();
      v.meta.products_data = products_data;
      v.payment_methods = JSON.parse(
        JSON.stringify(v.$props.module_settings.payment_methods || [])
      );
      v.$refs.generic_modal.show_modal();

      if (v.module_settings.integrate_fel) v.meta.emit_billing = true;
      if (v.module_settings.fel_default_municipality)
        v.meta.billing_municipality =
          v.module_settings.fel_default_municipality;
      if (v.module_settings.fel_default_department)
        v.meta.billing_department = v.module_settings.fel_default_department;
      if (v.module_settings.fel_default_zip_code)
        v.meta.billing_zip_code = v.module_settings.fel_default_zip_code;
    },
    save() {
      let v = this;
      let products = v.meta.products_data.products.map((p) => {
        return {
          i: p.product_id,
          p: p.sale_price,
          a: p.attributes
            ? p.attributes.map((a) => {
                return { name: a.name, value: a.selected_value };
              })
            : [],
        };
      });
      let filtered_payment = v.payment_methods
        .filter((pm) => {
          return pm.amount && pm.amount > 0;
        })
        .map((pm) => {
          return {
            name: pm.name,
            amount: pm.amount,
            document_number: pm.document_number,
          };
        });

      v.is_loading = true;

      put("/sale", {
        products: products,
        total: v.meta.products_data.total_amount,
        payment: filtered_payment,
        billing: {
          emit: v.meta.emit_billing,
          nit: v.meta.billing_nit,
          name: v.meta.billing_name,
          email: v.meta.billing_email,
          address: v.meta.billing_address,
          zip_code: v.meta.billing_zip_code,
          municipality: v.meta.billing_municipality,
          department: v.meta.billing_department,
        },
        warehouse_id: v.meta.inventory_warehouse_id,
      })
        .then(() => {
          v.$emit("success");
          v.$refs.generic_modal.close_modal();
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        })
        .finally(() => {
          v.is_loading = false;
        });
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        // name: "",
        // barcode: "",
        // sale_price: "",
        // settings: {},
      };
      v.payment_methods = [];
      v.error = "";
      v.is_loading = false;
      // v.uuid = "";
    },
    set_warehouse(warehouse) {
      let v = this;
      if (warehouse) {
        v.meta.inventory_warehouse_id = warehouse.warehouse_id;
      }
    },
  },
  mounted() {},
  watch: {
    // is_form_invalid() {
    //   let v = this;
    //   v.buttons[0].disabled = v.is_form_invalid || v.is_loading;
    // },
  },
};
</script>
<style></style>
